import React, { useState } from "react";
import ConfirmationModal from "../../../UI/ConfirmationModal/ConfirmationModal";
import FormErr from "../../../UI/FormErr/FormErr";
import Input from "../../../UI/Input/Input";
import Modals from "../../../UI/Modals/Modals";
import SecBTN from "../../../UI/SecBTN";
import SuccessModal from "../../../UI/SuccessModal/SuccessModal";
import userService from "../../../app/services/user.service";
import moment from "moment";
import { toast } from "react-toastify";
import Toast from "../../../UI/Toast/Toast";

const AddProfile = ({ user_id,getProfileData }) => {
  const [newProfile, setNewProfile] = useState("");
  const [err, setErr] = useState("");
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);

  const createProfileHandler = () => {
    setShow(true);
  };
  const onHideHandler = () => {
    setShow(false);
    setShow1(false);
    setShow2(false);
  };
  const addProfileHandler = () => {
    setShow(false)
    setShow1(true);
  };
  const yesHandler = () => {
    const body = {
      profile_name: newProfile,
      active: 1,
      created_by: user_id,
      created_on: moment(new Date()).format("YYYY-MM-DD H:mm:ss"),
    };
    userService
      .createProfile(body)
      .then((res) => {
        console.log(res);
        setShow2(true);
        setShow1(false);
        // getProfileData({loader:false});
        getProfileData();
        setNewProfile("");
      })
      .catch((err) => {
        console.log(err)
        toast.error("Something went wrong")
        alert("Something went wrong");
      });
  };
  const onChangeHandler = (e) => {
    setNewProfile(e.target.value);
    if (newProfile.length > 2) {
      setErr(null);
    }
    if (newProfile.length < 3 && newProfile.length > 0) {
      setErr("Profile Name should be greater than 2");
      return;
    }
    if (err === "Feild can't be empty" && newProfile.length > -1) {
      setErr(null);
    }
    if (newProfile.length > 2) {
      setErr(null);
    }
  };
  return (
    <>
      <SecBTN onClick={createProfileHandler} className="sec-btn">
        Add Profile
      </SecBTN>
      <Toast />
      <ConfirmationModal
        title={`Are you sure you want to Add “${newProfile}” Profile?`}
        show={show1}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        confirmTxt="Yes"
      />
      <SuccessModal
        show={show2}
        onHide={onHideHandler}
        title="Profile Added Successfully"
        btnTxt="Ok"
      />
      <Modals show={show} onHide={onHideHandler}>
        <h4 className="mb-3">Add Profile</h4>
        <label>Profile Name :</label>
        <Input
          value={newProfile}
          type="text"
          placeholder="Enter Profile Name"
          onChange={onChangeHandler}
        />
        {err && <FormErr>{err}</FormErr>}
        <div className="text-center mt-4">
          <SecBTN
            className={
              newProfile.length === 0 ? "sec-btn1-deactive" : "sec-btn1"
            }
            disabled={newProfile.length < 3}
            onClick={addProfileHandler}
          >
            Add Profile
          </SecBTN>
        </div>
      </Modals>
    </>
  );
};

export default AddProfile;
